import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        {/* 1. Hero */}
        <HeroSection />

        {/* 2. 读者评论 #comments - 3项 */}
        <CommentsSection />

        {/* 3. 人气榜单 #ranking - 7项 */}
        <RankingSection />

        {/* 4. 分类索引 #index - 9项 */}
        <IndexSection />

        {/* 5. 热门话题 #topics - 9项 */}
        <TopicsSection />

        {/* 6. 关于YY漫画 #about - 1项 */}
        <AboutSection />

        {/* 7. 精彩推荐 #media - 3项 */}
        <MediaSection />

        {/* 8. 重磅推荐 #carousel - 6项 */}
        <CarouselSection />

        {/* 9. 编辑精选 #cards - 7项 */}
        <CardsSection />

        {/* 10. 追更动态 #updates - 9项 */}
        <UpdatesSection />

        {/* 11. 阅读优势 #features - 4项 */}
        <FeaturesSection />

        {/* 12. 投稿联系 #contact - 1项 */}
        <ContactSection />

        {/* 13. 常见问题 #faq - 6项 */}
        <FaqSection />

        {/* 14. APP下载 #app - 1项 */}
        <AppSection />
      </main>

      <Footer />
    </div>
  );
}